import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { zip } from 'rxjs';
import { take } from 'rxjs/operators';
import { customerConfig } from '../store-provider';
import { LoyaltySsoService } from '../menu/services/loyalty-sso.service';
import { SsoPages } from './sso.pages';
import { ConfigService } from '../helpers/config.service';


@Injectable()
export class SsoService {
  private readonly pdt = 'pdt';
  constructor(
    private httpClient: HttpClient,
    private store: Store<any>,
    @Inject('API') private api,
    private readonly loyaltySsoService: LoyaltySsoService,
    private readonly initService: ConfigService
  ) {}

  redirectToSupportPage(menuItem) {
    let website_code = '';
    let locale = '';

    zip(this.store.pipe(select(customerConfig)), this.encryptedSSOParams())
      .pipe(take(1))
      .subscribe(([customer, sso]): void => {
        customer.customerConfig.stores.map(store => {
          if (store.store_code == customer.customerConfig.default_store_code) {
            locale = store.locale;
            website_code = customer.customerConfig.website_code;
          }
        });

        switch (menuItem.code) {
          case SsoPages.EDENRED_SUPPORT:
            this.openEdenredSuppportUrl();
            return;
          case SsoPages.ABOUT_AMADEUS:
            this.openExternalLink(menuItem.external_link);
            return;
        }
      });
  }

  openExternalLink(page) {
    const a = document.createElement('a');
    a.href = page.toString();
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
  }

  encryptedSSOParams() {
    return this.httpClient.get<any>(this.initService.getEnvConfig().AD_JAVA_API_URL + this.api.sso.ssoEncrypted());
  }

  openEdenredSuppportUrl() {
    this.loyaltySsoService.openLink('edenred-support-page');
  }

  getBaseUrl(): string {
    return localStorage.getItem('baseUrl');
  }


}
